import React from "react";
import { AddFilterBaseFunc, graphColors, IDimMDT, IFilterKeys, IFilters, IPlotData, RemoveFilterBaseFunc } from "models/core";
import { DashboardFilterKeys } from "models/mdt";
import { ChartOrientation, ChartType, QoolDashChart } from "../core";

interface IProps {
	plotData: { [mdtDiagYearKey: string]: { "MDT": number, "State": number } };
	mdtFacilityRef: IDimMDT[];
	activeFilters: IFilters<IFilterKeys>;
	addFilterFn: AddFilterBaseFunc<typeof DashboardFilterKeys>;
	removeFilterFn: RemoveFilterBaseFunc<typeof DashboardFilterKeys>;
	mdtName: string;
	cancerName: string;
}

/**
 * Reviews by service chart / My MDTs
 */
export function ThreeYearSurvivalChart(props: IProps) {
	const { plotData, mdtFacilityRef, activeFilters, mdtName, cancerName } = props;

	const labels = ["2010-2011", "2012-2014", "2015-2017", "2018-2020"];

	const survivalYears = 3;


	let mdtSurvival: IPlotData = { labels: [], values: [] };
	let stateSurvival: IPlotData = { labels: [], values: [] };



	let mdtId = mdtFacilityRef.find(x => x.nameAndFacility == mdtName)?.mdtNameId;
	labels.forEach(a => {
		if (plotData[mdtId + a + survivalYears + cancerName]) {
			mdtSurvival.labels.push(a)
			if (plotData[mdtId + a + survivalYears +  cancerName].MDT == -1) {
				mdtSurvival.values.push(1)
			} else {
				mdtSurvival.values.push(plotData[mdtId + a + survivalYears +  cancerName].MDT)
			}
			stateSurvival.labels.push(a)
			stateSurvival.values.push(plotData[mdtId + a + survivalYears +  cancerName].State)
		}
	})



	const valuesMDT = mdtSurvival.values;
	const labelsMDT = mdtSurvival.labels;
	const mdt = { "name": "My MDT", "labels": labelsMDT, "values": valuesMDT };

	const valuesState = stateSurvival.values;
	const labelsState = stateSurvival.labels;
	const state = { "name": "Queensland", "labels": labelsState, "values": valuesState };

	const tracesArray: any[] = [];
	tracesArray.push(mdt);
	tracesArray.push(state);

	const legend = (chartType: ChartType): JSX.Element => {

		if (chartType == ChartType.Table)
			return null;

		return (
			<div className="dash-legend">
				<div>
					<div className="key" style={{ backgroundColor: graphColors.default[0] }}></div>
					<div className="title">My MDT</div>
				</div>
				<div>
					<div className="key" style={{ backgroundColor: graphColors.default[1] }}></div>
					<div className="title">Queensland</div>
				</div>
			</div>

		)
	}

	return (
		<QoolDashChart
			xAxis={{ horizontalOrientation: { label: "", style: { range: [0, 110], autorange: false } }, verticalOrientation: { label: "" } }}
			yAxis={{ horizontalOrientation: { label: "" }, verticalOrientation: { label: "", style: { range: [0, 110], autorange: false } } }}
			chartOrder={{ horizontalOrientation: { reversed: false }, verticalOrientation: { reversed: false } }}
			defaultChartOrientation={ChartOrientation.Vertical}
			defaultChartType={ChartType.Bar}
			chartTitle="Overall Three Year Survival"
			filterKey={""}
			plotData={tracesArray}
			calculateRangeOnPlotDataIndex={0}
			activeFilters={props.activeFilters}
			addFilterFn={props.addFilterFn}
			removeFilterFn={props.removeFilterFn}
			filterFn={null}
			hoverText="%{fullData.name}"
			textFn={(v) => v.map(p => (p == 1 ? "NA" : p.toString() + "%"))}
			breadcrumb={null}
			chartIcons={{
				pie: false,
				line: false,
				help: ["Overall survival describes the proportion of people still alive after a specified time from their diagnosis.",
						"",
				 		"All causes of death are considered.",  
						"",     
						"Note: Survival Rate = NA",
						"When there is less than 10 patients we do not calculate survival.",
						"Survival rates of 100% may indicate low patient numbers."]
			}}
			chartDimensions={{
				chartHeightProportion: 50,
				parentColNumber: 12,
				tabColNumber: 4
			}}
			legend={legend}
			msgWhenHidden={"Please select a single MDT and Cancer to generate data"}
		/>
	)
}
